import axiosWithToken from 'services/clients/axios-with-token';
import _ from 'lodash';
import { objectKeysToSnakeCase, joinArrayParams } from 'utils/common';
import { fetchTerminalStatuses } from 'services/clients/watchList';

import { transformContainers, addTerminalStatuses } from './transform-containers';

export async function fetchContainers(params = {}, containerNumbers = [], signal = null) {
  const sortBy = containerNumbers.length > 0 ? 'container_numbers_input' : 'per_diem';
  const promise = axiosWithToken.post(
    '/core/api/v1/containers/watch-list',
    {
      create: true,
      container_numbers: containerNumbers,
    },
    {
      params: _.mapValues(objectKeysToSnakeCase({ sortBy, ...params }), joinArrayParams),
      signal,
    }
  );

  const {
    data: { count, results, no_capacity_containers },
  } = await promise;

  const containersTransformed = transformContainers(results, containerNumbers);
  const terminalStatusResponse = await fetchTerminalStatuses(containersTransformed, signal);
  const containerList = addTerminalStatuses(containersTransformed, terminalStatusResponse);

  return {
    noCapacityContainers: no_capacity_containers || [],
    containerList,
    containerListRowCount: count,
  };
}
